import { Injectable, NgZone } from '@angular/core';
import { IUser } from 'app/interfaces/user.interface';
import { ApiRoutes } from 'app/routes/app.routes';
import { ActiveUser } from 'app/utils/helpers.utils';
import { BehaviorSubject, Observable } from 'rxjs';

interface INotifications {
  state: boolean;
  message: string;
  timeout?: number;
  severity: 'error' | 'warning' | 'info' | 'success' | 'neutral';
  metaData?: any;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private initialState: INotifications = {
    state: false,
    message: undefined,
    timeout: 5000,
    severity: 'neutral',
  };



  private state: BehaviorSubject<INotifications> =
    new BehaviorSubject<INotifications>(this.initialState);
  public _state: Observable<INotifications> = this.state.asObservable();
  private baseUrl = ApiRoutes.api.host;

  public activities = new BehaviorSubject<any>({});

  constructor(private zone: NgZone) {
    this.state.subscribe(({ state, severity }) => {
      if (state) {
        setTimeout(() => this.hideNotification(), severity === 'error' ? 60000 : this.initialState.timeout);
      }
    });
  }

  showNotifications(notifications: Omit<INotifications, 'state'>) {
    this.state.next({ ...notifications, state: true });
  }

  hideNotification() {
    this.state.next(this.initialState);
  }

  listen(): Observable<any> {
    const user: IUser = ActiveUser();
    return new Observable(observer => {
      const eventSource = new EventSource(`${this.baseUrl}api/v1/rt/notifications/pull/${user?.owner_id}`);

      eventSource.onmessage = event => {
        this.zone.run(() => {
          observer.next(JSON.parse(event.data));
          this.activities.next(JSON.parse(event.data));
        });
      };

      eventSource.onerror = error => {
        this.zone.run(() => {
          observer.error(error);
        });
      };

      return () => {
        eventSource.close();
      };
    });
  }
}
